import React from "react";

/**
 * Segmented switcher pill — Home screen Translate / Currency / Tip.
 *
 * Each segment ships its own pre-styled colored icon so the visual
 * matches the wordmark accents (Translate=blue, Currency=green,
 * Tip=orange). Active segment gets a navy text and an orange underline;
 * inactive segments dim to navy-soft but keep their colored sticker.
 */
export default function SegmentedSwitcher({ value, onChange, items }) {
  return (
    <div
      data-testid="segmented-switcher"
      className="bg-white shadow-soft border border-navy/5 p-1.5 rounded-full flex w-full"
    >
      {items.map(({ id, label, renderIcon }) => {
        const active = value === id;
        return (
          <button
            key={id}
            data-testid={`seg-${id}`}
            onClick={() => onChange(id)}
            className={`flex-1 flex items-center justify-center gap-1.5 py-2 text-sm font-jakarta font-bold rounded-full transition-all ${
              active
                ? "bg-orange text-white shadow-soft"
                : "text-navy"
            }`}
            aria-pressed={active}
          >
            {renderIcon && renderIcon({ active })}
            {label}
          </button>
        );
      })}
    </div>
  );
}
